<typography-legacy text-small-semibold>
  <div class="mb-sm" [innerHTML]="controlConfig.label | translate"></div>
</typography-legacy>

<div *ngFor="let question of questions; let i = index" class="mb-sm">
  <typography-legacy>
    <p class="secondary-text mb-sm" [innerHTML]="question.text | translate"></p>
  </typography-legacy>
  <typography-legacy>
    <p class="hint mb-sm" [innerHTML]="question.questionHintText | translate"></p>
  </typography-legacy>
  <ng-container [ngSwitch]="question.style">
    <ng-container *ngSwitchCase="'checkbox'">
      <ng-container *ngTemplateOutlet="checkboxStyle; context: { $implicit: controlConfig, question: question }"></ng-container>
    </ng-container>
    <ng-container *ngSwitchDefault>
      <ng-container *ngTemplateOutlet="radioStyle; context: { $implicit: controlConfig, question: question }"></ng-container>
    </ng-container>
  </ng-container>


</div>

<ng-template #checkboxStyle let-controlConfig let-question=question>
  <div class="mb-xs" *ngFor="let choice of question.choices">
    <bw-checkbox-legacy
      [name]="controlConfig.key"
      [value]="choice"
      [label]="choice | translate"
      [checked]="question.selectedChoices[choice]"
      (checkboxChanged)="updateFormOnChange(question, choice)"
    ></bw-checkbox-legacy>
  </div>
</ng-template>

<ng-template #radioStyle let-controlConfig let-question=question>
  <ng-container *ngFor="let choice of question.choices">
    <bw-radio-legacy
      [name]="controlConfig.key"
      [value]="choice"
      [label]="choice | translate"
      [startSelected]="
      controlConfig.inputOptions?.initialValue === question.choiceValueMapping[choice]
      || controlConfig.inputOptions?.initialValue === choice"
      (radioClick)="updateFormOnChange(question, choice)"
    ></bw-radio-legacy>
  </ng-container>

</ng-template>
